module.exports = __webpack_public_path__ + "img/visitor-view-profile-illustration.95b0b3c0.svg";